(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["carousel-autoplay"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('white-apple-autoplay')) {
    customElements.define('white-apple-autoplay', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.owner = this.closest('white-apple-hero, white-apple-benefits');
        if (!this.owner) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.mobile = matchMedia('(max-width: 749px)');
        this.paused = this.motion.matches;
        this.visible = false;
        this.hovered = false;
        this.touching = false;
        this.delay = Math.max(2000, Number(this.dataset.interval) * 1000 || 3000);
        this.owner.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') { this.hovered = true; this.schedule(); } }, options);
        this.owner.addEventListener('pointerleave', event => { if (event.pointerType === 'mouse') { this.hovered = false; this.schedule(); } }, options);
        this.owner.addEventListener('pointerdown', () => { this.touching = true; this.schedule(); }, options);
        document.addEventListener('pointerup', () => { if (this.touching) { this.touching = false; this.schedule(); } }, options);
        document.addEventListener('pointercancel', () => { this.touching = false; this.schedule(); }, options);
        this.owner.addEventListener('focusin', () => this.schedule(), options);
        this.owner.addEventListener('focusout', () => queueMicrotask(() => this.schedule()), options);
        this.owner.addEventListener('click', () => this.schedule(), options);
        this.owner.addEventListener('scroll', () => this.schedule(), { ...options, capture: true, passive: true });
        document.addEventListener('visibilitychange', () => this.schedule(), options);
        this.mobile.addEventListener('change', () => this.schedule(), options);
        this.motion.addEventListener('change', () => { this.paused = this.motion.matches; this.schedule(); }, options);
        this.owner.addEventListener('shopify:block:select', () => { this.paused = true; this.schedule(); }, options);
        this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.schedule(); }, { threshold: 0.15 });
        this.observer.observe(this.owner);
      }
      schedule() {
        clearTimeout(this.timer);
        if (!this.isConnected || this.paused || !this.visible || document.hidden || this.hovered || this.touching || this.owner.contains(document.activeElement) || (this.hasAttribute('data-mobile-only') && !this.mobile.matches)) return;
        this.timer = setTimeout(() => {
          if (!this.owner.drag) this.owner.dispatchEvent(new CustomEvent('carousel:advance'));
          this.schedule();
        }, this.delay);
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        this.controller?.abort();
        this.controller = null;
        this.observer?.disconnect();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card-gallery"] && !Shopify.designMode) return;
  try {
    class ProductCardGallery extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.track = this.querySelector('.product-card-gallery__track');
      this.templates = [...this.querySelectorAll('[data-card-gallery-image]')];
      if (!this.track || !this.templates.length) return;
      this.frames = [...this.track.querySelectorAll(':scope > .product-card-gallery__slide')];
      this.positions = [...this.querySelectorAll('.product-card-gallery__positions span')];
      this.requestedIndex = 0;
      this.version = 0;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.addEventListener('pointerenter', (event) => {
        if (!this.canHover(event)) return;
        this.templates.forEach((template, index) => this.prepare(index + 1));
        this.move(event);
      }, options);
      this.addEventListener('pointermove', (event) => this.move(event), options);
      this.addEventListener('pointerleave', () => this.reset(), options);
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.reset();
      }, options);
    }

    canHover(event) {
      return event.pointerType !== 'touch' && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    }

    prepare(index) {
      if (this.frames[index]) return this.frames[index];
      if (index > 1) this.prepare(index - 1);
      const frame = this.templates[index - 1].content.firstElementChild.cloneNode(true);
      const image = frame.querySelector('img');
      if (image) image.loading = 'eager';
      this.track.append(frame);
      this.frames[index] = frame;
      return frame;
    }

    move(event) {
      if (!this.canHover(event)) return;
      const bounds = this.getBoundingClientRect();
      if (!bounds.width) return;
      const fraction = Math.max(0, Math.min(0.999999, (event.clientX - bounds.left) / bounds.width));
      this.select(1 + Math.floor(fraction * this.templates.length));
    }

    async select(index) {
      if (index === this.requestedIndex) return;
      this.requestedIndex = index;
      const version = ++this.version;
      const frame = this.prepare(index);
      const image = frame.querySelector('img');
      try {
        await image?.decode?.();
        if (image) await window.WhiteAppleTheme?.fitProductImage?.(image);
      } catch {
        if (version === this.version) this.reset();
        return;
      }
      if (version !== this.version || !this.isConnected) return;
      this.show(index);
    }

    show(index) {
      this.track.style.transform = `translate3d(${-index * 100}%, 0, 0)`;
      this.frames.forEach((frame, position) => frame.setAttribute('aria-hidden', String(position !== index)));
      this.positions.forEach((position, offset) => position.classList.toggle('is-active', offset === index - 1));
    }

    reset() {
      this.version += 1;
      this.requestedIndex = 0;
      this.show(0);
    }

    disconnectedCallback() {
      if (!this.abort) return;
      this.reset();
      this.abort.abort();
      this.abort = null;
    }
  }

  if (!customElements.get('product-card-gallery')) {
    customElements.define('product-card-gallery', ProductCardGallery);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card-highlights"] && !Shopify.designMode) return;
  try {
    class ProductCardHighlights extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      const move = (next) => {
        if (document.activeElement === this || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
        const direction = getComputedStyle(this).direction === 'rtl' ? -1 : 1;
        const slot = this.firstElementChild?.getBoundingClientRect().width || this.clientWidth;
        const page = Math.max(1, Math.round(this.clientWidth / slot)) * slot;
        this.scrollTo({
          left: next ? direction * Math.min(page, this.scrollWidth - this.clientWidth) : 0,
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
        });
      };
      this.addEventListener('pointerenter', () => move(true), options);
      this.addEventListener('pointerleave', () => move(false), options);
      this.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        event.stopPropagation();
        const direction = getComputedStyle(this).direction === 'rtl' ? -1 : 1;
        const slot = this.firstElementChild?.getBoundingClientRect().width || this.clientWidth;
        let left = this.scrollLeft + (event.key === 'ArrowRight' ? slot : -slot);
        if (event.key === 'Home') left = 0;
        if (event.key === 'End') left = direction * (this.scrollWidth - this.clientWidth);
        this.scrollTo({ left, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      }, options);
    }

    disconnectedCallback() {
      this.abort?.abort();
      this.abort = null;
    }
  }

  if (!customElements.get('product-card-highlights')) {
    customElements.define('product-card-highlights', ProductCardHighlights);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-showcase-styles"] && !Shopify.designMode) return;
  try {
    (() => {
    const selector = '.product-grid .product-card[data-product-card]';
    const observed = new Set();
    let frame;
    const schedule = () => {
      if (frame) return;
      frame = requestAnimationFrame(equalize);
    };
    const resizeObserver = new ResizeObserver(schedule);
    const outerHeight = element => {
      if (!element) return 0;
      const style = getComputedStyle(element);
      if (style.display === 'none') return 0;
      return element.getBoundingClientRect().height + (parseFloat(style.marginTop) || 0) + (parseFloat(style.marginBottom) || 0);
    };

    function equalize() {
      frame = null;
      const elements = new Set();
      const grids = new Map();
      document.querySelectorAll(selector).forEach(card => {
        const grid = card.closest('.product-grid');
        const title = card.querySelector('.product-card__title');
        if (!grid || !title || !card.getBoundingClientRect().width) return;
        const price = card.querySelector('.price');
        const vendor = card.querySelector('.product-card__vendor');
        const rating = card.querySelector('.product-card__rating');
        const swatches = card.querySelector('.product-card__swatches');
        [grid, title, price, vendor, rating, swatches].filter(Boolean).forEach(element => elements.add(element));
        let group = grids.get(grid);
        if (!group) {
          const style = getComputedStyle(grid);
          const stackedMobile = window.matchMedia('(max-width: 749px)').matches && style.display === 'grid' && !style.gridAutoFlow.includes('column') && style.gridTemplateColumns.trim().split(/\s+/).length === 1;
          group = { top: grid.getBoundingClientRect().top, titleMinimum: stackedMobile ? 0 : 50, rows: [] };
          grids.set(grid, group);
        }
        const top = card.getBoundingClientRect().top - group.top;
        let row = group.rows.find(candidate => Math.abs(candidate.top - top) < 2);
        if (!row) {
          row = { top, title: group.titleMinimum, vendor: 0, review: 0, swatches: 0, price: 0, cards: [] };
          group.rows.push(row);
        }
        const separatePrice = price && getComputedStyle(price).gridRowStart === '3';
        row.title = Math.max(row.title, title.getBoundingClientRect().height, separatePrice ? 0 : outerHeight(price));
        row.vendor = Math.max(row.vendor, outerHeight(vendor));
        row.review = Math.max(row.review, outerHeight(rating));
        row.swatches = Math.max(row.swatches, outerHeight(swatches));
        row.price = Math.max(row.price, separatePrice ? outerHeight(price) : 0);
        row.cards.push(card);
      });
      grids.forEach(({ rows }) => rows.forEach(row => {
        const values = {
          '--product-card-title-height': row.title,
          '--card-vendor-height': row.vendor,
          '--card-review-height': row.review,
          '--card-swatch-height': row.swatches,
          '--card-price-height': row.price
        };
        row.cards.forEach(card => Object.entries(values).forEach(([property, height]) => {
          const value = Math.ceil(height) + 'px';
          if (card.style.getPropertyValue(property) !== value) card.style.setProperty(property, value);
        }));
      }));
      observed.forEach(element => {
        if (!elements.has(element)) {
          resizeObserver.unobserve(element);
          observed.delete(element);
        }
      });
      elements.forEach(element => {
        if (!observed.has(element)) {
          observed.add(element);
          resizeObserver.observe(element);
        }
      });
    }

    new MutationObserver(records => {
      if (records.some(record => record.target.parentElement?.closest('.product-card[data-product-card]') || record.target.closest?.('.product-card[data-product-card]') || [...record.addedNodes, ...record.removedNodes].some(node => node.nodeType === 1 && (node.matches?.('.product-card') || node.querySelector?.('.product-card'))))) schedule();
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
    window.addEventListener('resize', schedule, { passive: true });
    document.fonts.ready.then(schedule);
    schedule();
  })();
  } catch(e) { console.error(e); }
})();

})();
